import React, { useMemo, useRef, useCallback } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { uploadSingleFile } from "../../../../api/files";
import { SERVER_URL } from "../../../../utils";
import "./SupportReplyEditor.css";

function resolvePublicMediaUrl(raw) {
	const p = String(raw || "").trim();
	if (!p) return "";
	if (/^https?:\/\//i.test(p) || p.startsWith("data:")) return p;
	if (p.startsWith("/")) return `${String(SERVER_URL || "").replace(/\/$/, "")}${p}`;
	return `${String(SERVER_URL || "").replace(/\/$/, "")}/${p.replace(/^\/+/, "")}`;
}

export default function SupportReplyEditor({ value, onChange, disabled = false, placeholder }) {
	const quillRef = useRef(null);
	const fileInputRef = useRef(null);

	const insertImage = useCallback(async (file) => {
		if (!file || disabled) return;
		const res = await uploadSingleFile(file, "support");
		const url = resolvePublicMediaUrl(res?.data?.fileURL);
		if (!url) return;
		const editor = quillRef.current?.getEditor?.();
		if (!editor) return;
		const range = editor.getSelection(true);
		const index = range ? range.index : editor.getLength();
		editor.insertEmbed(index, "image", url, "user");
		editor.setSelection(index + 1);
	}, [disabled]);

	const imageHandler = useCallback(() => {
		if (disabled) return;
		const input = fileInputRef.current;
		if (input) input.click();
	}, [disabled]);

	const onPickImage = async (e) => {
		const file = e.target.files?.[0];
		e.target.value = "";
		if (!file) return;
		try {
			await insertImage(file);
		} catch (err) {
			console.error("support image upload failed", err);
		}
	};

	const modules = useMemo(
		() => ({
			toolbar: {
				container: [
					[{ header: [1, 2, 3, false] }],
					["bold", "italic", "underline", "strike"],
					[{ list: "ordered" }, { list: "bullet" }],
					[{ color: [] }, { background: [] }],
					["link", "image"],
					["blockquote"],
					["clean"],
				],
				handlers: { image: imageHandler },
			},
		}),
		[imageHandler]
	);

	const formats = [
		"header",
		"bold",
		"italic",
		"underline",
		"strike",
		"list",
		"bullet",
		"color",
		"background",
		"link",
		"image",
		"blockquote",
	];

	return (
		<div className={`support-reply-editor${disabled ? " support-reply-editor--disabled" : ""}`}>
			<input
				ref={fileInputRef}
				type="file"
				accept="image/*"
				style={{ display: "none" }}
				onChange={onPickImage}
			/>
			<ReactQuill
				ref={quillRef}
				theme="snow"
				value={value || ""}
				onChange={onChange}
				modules={modules}
				formats={formats}
				readOnly={disabled}
				placeholder={placeholder || "Redacta la respuesta para el usuario…"}
			/>
		</div>
	);
}
